import { render } from "./SidebarDesktop.vue?vue&type=template&id=d41aca10&scoped=true&ts=true"
import script from "./SidebarDesktop.vue?vue&type=script&lang=ts"
export * from "./SidebarDesktop.vue?vue&type=script&lang=ts"

import "./SidebarDesktop.vue?vue&type=style&index=0&id=d41aca10&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d41aca10"]])

export default __exports__